module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTE4MCIgaGVpZ2h0PSI2NCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDAgTDggMCBMOCA2NCBMMCA2NCBaIiBmaWxsPSIjRjdGN0Y3IiAvPgogIDxwYXRoIGQ9Ik0xMTcyIDAgTDExODAgMCBMMTE4MCA2NCBMMTE3MiA2NCBaIiBmaWxsPSIjRjdGN0Y3IiAvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/components/rhombus/rhombus-outline-middle.svg
// module id = 444
// module chunks = 35783957827783